import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CheckboxSizes } from '../../../../components/checkbox/checkbox.component';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { PickerValue } from '../../../../components/generic-picker/generic-picker.component';
import {
  EmployeePayrollTotalsArgs,
  NewClientSetupArgs,
  ReportDownloadArgs,
  ReportGeneratedArgs
} from '../../../../models/reports';
import { parseDatePickerValue } from '../../../../utils/datepicker-value-parser';
import moment from 'moment';
import { DownloadFormatOption } from '../report-buttons/report-buttons.component';

@Component({
  selector: 'lib-new-client-setup',
  templateUrl: './new-client-setup.component.html',
  styleUrls: ['./new-client-setup.component.css'],
  standalone: false
})
export class NewClientSetupComponent implements OnInit {
  @Input()
  public clientCode: string;
  @Output()
  public reportGenerated = new EventEmitter<ReportGeneratedArgs>();
  @Output()
  public reportDownloadClicked = new EventEmitter<ReportDownloadArgs>();
  public formats: DownloadFormatOption[] = [
    DownloadFormatOption.Excel(),
    DownloadFormatOption.PDF()
  ];
  private readonly ENDPOINT = 'NewClientSetup';
  checkboxSizes = CheckboxSizes;
  form: UntypedFormGroup;
  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    const now = new Date();
    const pickerVal: PickerValue = {
      value: now.getMonth() + 1,
      year: now.getFullYear()
    };
    this.form = this.fb.group(
      {
        asOfDate: this.fb.control(pickerVal, [Validators.required]),
        displayClientAndEmployeeSetupInfo: this.fb.control(false),
        includeEmployeeTotals: this.fb.control(false),
        includeClientTotals: this.fb.control(false)
      },
      { validators: [atLeastOneCheckbox] }
    );
  }

  public generateReport() {
    const args = this._getModel();
    console.log(args);
    this.reportGenerated.emit({ args, endpoint: this.ENDPOINT });
  }

  public downloadReport(format: string) {
    const args = this._getModel();
    const month = args.AsOfDate.toLocaleString('default', { month: 'long' });
    const now = moment().format('MMDDYYYY');
    this.reportDownloadClicked.emit({
      args,
      endpoint: this.ENDPOINT,
      filename: `New Client Setup_${
        this.clientCode
      }_${month} ${args.AsOfDate.getFullYear()}_${now}.${format}`,
      format
    });
  }

  private _getModel() {
    const formModel = this.form.value;
    const args: NewClientSetupArgs = {
      AsOfDate: new Date(formModel.asOfDate.year, formModel.asOfDate.value, 0),
      DisplayClientAndEmployeeSetupInfo: formModel.displayClientAndEmployeeSetupInfo,
      IncludeClientTotals: formModel.includeClientTotals,
      IncludeEmployeeTotals: formModel.includeEmployeeTotals
    };
    return args;
  }
}

export const atLeastOneCheckbox: ValidatorFn = (control: AbstractControl) => {
  const displayClient = control.get('displayClientAndEmployeeSetupInfo').value;
  const includeClient = control.get('includeClientTotals').value;
  const includeEmployee = control.get('includeEmployeeTotals').value;

  if (!displayClient && !includeClient && !includeEmployee) {
    return { atLeastOneCheckbox: true };
  }
  return null;
};
